
import DrawLeft2 from './../../../assets/home-ilustracao-paciente.png';
import DrawRight2 from './../../../assets/home-ilustracao-profissional-saude.png';
import React from 'react';
import { NavLink } from 'react-router-dom';
import './../../Tela_Sobre/Tela_Manual/style.css'
import Grid from '@material-ui/core/Grid';
import SideNav from './../../../components/SideNav';
import logotoda from './../../../assets/logo-rede-convida-home.png';
import linkedin from './../../../assets/linkedin.png'
import instagram from './../../../assets/instagram.png'

export default function Tela_Manual() {    
    return(
        <>      
            <SideNav />
            <body>
            
            < section id= "tela1m" >
            <img src={DrawRight2} alt="Convida" id="primeiraimgm"></img>
                <div class="textotela1m">
                    <h1 class= "estilo1m" id="introempresa">
                        <b>Profissional da Saúde</b> 
                    </h1>
                    
                    <h4 class="estilo12m">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temporin 
                        cididunt ut labore et dolore magnaali. 
                    </h4>
                    
                    <a href="https://drive.google.com/file/d/1TzorBWVKbljmqvBmIznsGpP7ajZbdk0a/view?usp=sharing" class="button1m"><b>Veja o manual de uso!</b></a>
                    </div> 
            </section>

            < section id= "tela2m2" >
            <img src={DrawLeft2} alt="Convida" id="primeiraimgm2"></img>
                <div class="textotela2m2">
                    <h1 class= "estilo1m2" id="introempresa">
                        <b>Representante de Instituição</b> 
                    </h1>
                    
                    <h4 class="estilo12m2">
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod temporin 
                        cididunt ut labore et dolore magnaali. 
                    </h4>
                    
                    <a href="https://drive.google.com/file/d/1Z6pAptVia5ac1Yoth9LF81gxMvwM5oGh/view?usp=sharing" class="button1m2"><b>Veja o manual de uso!</b></a>
                    </div> 
            </section>





            < section id= "footer" >

                <a href="pagina2.html" class="logos">
                <img src={logotoda} alt="Logo" id="logofooter"></img>
                </a>
                    <h1 class= "estilofooter" id="introempresa">
                        emai@institucional.com.br | lorem ipsum dolor
                    </h1>
                    <Grid container spacing={0} direction="row" justify="center" alignItems="center" style={{ minHeight: '10vh', maxWidth: '100%' }}>
                    <Grid item xs={0} sm={5} md={5} lg={5}></Grid>

                    <Grid item xs={12} sm={2} md={2} lg={2} align="center" position="botton"> 
                    <div class="sociais">
                    <img href="https://www.linkedin.com/company/rede-convida" class="logolinkedin" src={linkedin} alt="Linkedin"></img>
                    <img href="https://www.instagram.com/redeconvida/" class= "logoinsta" src={instagram} alt="Instagram"></img>
                    </div>
                    </Grid>

                    <Grid item xs={0} sm={5} md={5} lg={5}></Grid>
                    </Grid>
            </section>

            </body> 

        </>
    );
}